import { apiClient } from '@/shared/api'

import { TSimpleReviewTemplate } from '../model/schema'

type SimpleReviewTemplateResponse = TSimpleReviewTemplate[]

export const getSimpleReviewTemplates = async () => {
  const response = await apiClient.get<SimpleReviewTemplateResponse>({
    endpoint: `/contracts/simple-review-templates`,
  })

  return response
}
